// frontend/src/AuthContext.js
import React, { createContext, useState, useEffect, useMemo } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);
  const [loginModalOpen, setLoginModalOpen] = useState(false);

  const storedRole = useMemo(() => localStorage.getItem('role'), []);
  const storedAuth = useMemo(() => localStorage.getItem('auth'), []);
  const storedName = useMemo(() => localStorage.getItem('name'), []);
  const storedUsername = useMemo(() => localStorage.getItem('username'), []);


  useEffect(() => {
    // Carrega o estado do localStorage apenas na inicialização

    if (storedRole && storedAuth && storedName) {
      setIsLoggedIn(true);
      // Prefere o username canônico gravado no login. O Basic Auth guarda o que foi
      // digitado, que pode ser o e-mail — e aí GET /api/users/username/{username}
      // não acha ninguém. O fallback cobre sessões abertas antes desta mudança.
      setUsername(storedUsername || atob(storedAuth).split(':')[0]);
      setRole(storedRole);
      setName(storedName);
    }
    setIsLoadingAuth(false);
  }, [storedRole, storedAuth, storedName, storedUsername]); // executa apenas no mount

  return (
    <AuthContext.Provider value={{
      isLoggedIn,
      setIsLoggedIn,
      username,
      setUsername,
      role,
      setRole,
      isLoadingAuth,
      name,
      setName,
      loginModalOpen,
      setLoginModalOpen
    }}>
      {children}
    </AuthContext.Provider>
  );
};